import { Component } from '@angular/core';
import { LucideAngularModule, Power } from "lucide-angular";
import { AuthenticationService } from "src/app/authentications/authentication.service";
import { AsyncPipe } from "@angular/common";
import { MatButtonModule } from "@angular/material/button";
import { MatMenuModule } from "@angular/material/menu";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { TranslateModule, TranslateService } from "@ngx-translate/core";

export interface ILanguageElement {
  label: string;
  code: string;
}

// TODO: Remove when Lux Award is finished
@Component({
  selector: 'fspro-header-lux',
  templateUrl: './header-lux.component.html',
  styleUrl: './header-lux.component.scss',
  imports: [LucideAngularModule, AsyncPipe, MatButtonModule, MatMenuModule, MatFormFieldModule, MatSelectModule, TranslateModule],
})
export class HeaderLuxComponent {

  public currentLanguage = this.translateService.currentLang || 'en';
  public languages: ILanguageElement[] = [
    { code: 'bg', label: '(BG) Български' },      // Bulgare
    { code: 'cs', label: '(CS) Čeština' },        // Tchèque
    { code: 'da', label: '(DA) Dansk' },          // Danois
    { code: 'de', label: '(DE) Deutsch' },        // Allemand
    { code: 'el', label: '(EL) Ελληνικά' },       // Grec
    { code: 'en', label: '(EN) English' },        // Anglais
    { code: 'es', label: '(ES) Español' },        // Espagnol
    { code: 'et', label: '(ET) Eesti' },          // Estonien
    { code: 'fi', label: '(FI) Suomi' },          // Finnois
    { code: 'fr', label: '(FR) Français' },       // Français
    { code: 'ga', label: '(GA) Gaeilge' },        // Irlandais
    { code: 'hr', label: '(HR) Hrvatski' },       // Croate
    { code: 'hu', label: '(HU) Magyar' },         // Hongrois
    { code: 'it', label: '(IT) Italiano' },       // Italien
    { code: 'lt', label: '(LT) Lietuvių' },       // Lituanien
    { code: 'lv', label: '(LV) Latviešu' },       // Letton
    { code: 'mt', label: '(MT) Malti' },          // Maltais
    { code: 'nl', label: '(NL) Nederlands' },     // Néerlandais
    { code: 'pl', label: '(PL) Polski' },         // Polonais
    { code: 'pt', label: '(PT) Português' },      // Portugais
    { code: 'ro', label: '(RO) Română' },         // Roumain
    { code: 'sk', label: '(SK) Slovenčina' },     // Slovaque
    { code: 'sl', label: '(SL) Slovenščina' },    // Slovène
    { code: 'sv', label: '(SV) Svenska' }         // Suédois
  ];

  protected readonly Power = Power;


  constructor(
    protected readonly authenticationService: AuthenticationService,
    private readonly snackbar: MatSnackBar,
    private readonly router: Router,
    private readonly translateService: TranslateService,
  ) {
  }

  ngOnInit() {
    const saved = localStorage.getItem('lang');

    if (saved && this.isSupported(saved)) {
      this.currentLanguage = saved;
      this.translateService.use(saved);
      return;
    }

    const browserLang = navigator.language?.split('-')[0].toLowerCase();

    if (browserLang && this.isSupported(browserLang)) {
      this.currentLanguage = browserLang;
      this.translateService.use(browserLang);
      localStorage.setItem('lang', browserLang);
      return;
    }

    this.currentLanguage = 'en';
    this.translateService.use('en');
    localStorage.setItem('lang', 'en');
  }

  logout(): void {
    this.authenticationService.signOut().then(() => {
      this.snackbar.open(
        'You have been signed out!', 'Close',
        { duration: 5000, verticalPosition: 'top', horizontalPosition: 'center', panelClass: 'info-snackbar' }
      );
      this.router.navigateByUrl('/page/signed-out-lux-audience-award').then();
    });
  }

  changeLanguage(lang: string) {
    this.currentLanguage = lang;
    this.translateService.use(lang);
    localStorage.setItem('lang', lang);
  }

  private isSupported(code: string): boolean {
    return this.languages.some(l => l.code === code);
  }
}
